/**
 * Which stored credentials an experiment ran with, under its header:
 * "emr_token: MedStar sandbox". Labels come from the agent's spec when it loads,
 * else the raw key. Only the name shows, never a value (the API never sends one).
 * Run settings and fixed inputs are the agent's own setup, kept in the input
 * mapping, so they are not repeated here.
 */

import { useAgentSpec } from "@/features/agents/hooks";
import type { ExperimentSummary } from "../types";

export function CredentialsLine({ experiment: e }: { experiment: ExperimentSummary }) {
  const creds = Object.entries(e.credential_refs ?? {});
  const spec = useAgentSpec(creds.length ? (e.agent?.id ?? null) : null).data;
  if (!creds.length) return null;
  const label = (key: string) => spec?.run_settings.find((s) => s.key === key)?.label ?? key;

  return (
    <dl aria-label="Credentials" className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-muted">
      {creds.map(([k, ref]) => (
        <div key={k} className="flex gap-1">
          <dt>{label(k)}:</dt>
          <dd className="m-0 text-body">{typeof ref === "string" ? "stored credential" : ref.name}</dd>
        </div>
      ))}
    </dl>
  );
}
